import { ValuesOf } from '@tmapy/beetlejuice-utils';

export const VYJADRENI_PRIJATO = { TRUE: 'TRUE', FALSE: 'FALSE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type VYJADRENI_PRIJATO = ValuesOf<typeof VYJADRENI_PRIJATO>;
